import { memo } from 'react';
import Image from "next/legacy/image";
import styled from 'styled-components';

import getImagePath from '@utils/getImagePath';
import { imageRectangleLoader } from '@utils/imageLoaders';

const Wrapper = styled.div`
  height: 500px;
  margin: 4rem auto -2rem;
  position: relative;
`;

const Container = styled.div`
  bottom: 0;
  height: 500px;
  left: 50%;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(-50%);
  width: 100vw;
`;

const Banner = ({ image }) => {
  const blurImage = getImagePath({
    dimensions: '30x0',
    quality: 20,
    url: image.url,
  });
  const fullImage = getImagePath({ url: image.url });

  return (
    <Wrapper>
      <Container>
        <Image
          alt={image.alt}
          blurDataURL={blurImage}
          loader={imageRectangleLoader}
          objectFit="cover"
          layout="fill"
          placeholder="blur"
          src={fullImage}
        />
      </Container>
    </Wrapper>
  );
};

export default memo(Banner);
